import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../../context/AppContext";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Col, Modal, Row } from "antd";
import "./../../assets/css/authorizePage.css";
import Input from "../../components/custom/input/input/Input";
import { useNavigate } from "react-router-dom";
import HButton from "../../components/custom/input/button/Button";
import useHttp from "../../hooks/useHttp";
import { successNotification } from "../utils/CommonNotifications";
import { CommonLoadingV2, handleBuyNumberClick, Logo, MessageAreaInfo } from "../utils/CommonVessels";
import { findServiceInfoByServiceId, getHighUsageAlertMessage, getRandomNumber } from "../utils/commonUtils";
import AuthorizeButtonForSdkType from "./AuthorizeButtonForSdkType";
import AuthorizeButtonForUnipileAuth from "./AuthorizeButtonForUnipileAuth";
import HNotification from "../../components/custom/notification/HNotification";

function importAllImage(r) {
  let images = {};
  r.keys().map((item) => {
    images[item.replace("./", "")] = r(item);
    return null;
  });

  return images;
}
export const servicesImages = importAllImage(require.context("./../../assets/images/", false, /\.(png|jpe?g|svg)$/));

const labelVariables = {
  twilio: {
    username: "Account SID",
    password: "Auth Token",
  },
  twilio_voice: {
    username: "Account SID",
    password: "Auth Token",
  },
  twilio_whatsapp: {
    username: "Account Sid",
    password: "Account Token",
  },
  ClickSend: {
    username: "Username",
    password: "Password",
  },
  plivo: {
    username: "Auth Id",
    password: "Auth Token",
  },
  vonage: {
    username: "Account name",
    password: "Account secret",
  },
  burstsms: {
    username: "Api key",
    password: "Api secret",
  },
  telnyx: {
    username: "Api key",
    password: "Api secret",
  },
};

function AuthorizePage({ rightServiceObj, setRightServiceObj, setSuccessAuthModal, authorizeButtonName, onAuthorizationSuccess = () => {} }) {
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [appLogo, setAppLogo] = useState("");
  const [rightServiceTitle, setRightServiceTitle] = useState("");
  const [authorizeType, setAuthorizeType] = useState("");
  const [authorizationSuccess, setAuthorizationSuccess] = useState(false);
  const osyncId = appProperties.osyncId;
  const integId = rightServiceObj?.integId;
  const serviceId = rightServiceObj?.serviceId;
  const rightServiceName = appProperties.rightServiceName;
  const propsData = {
    osyncId: osyncId,
    integId: integId,
    serviceId: serviceId,
    rightServiceName: rightServiceName,
    authorized: rightServiceObj?.authorized,
  };
  const { fetchData } = useHttp();

  const authorizationSuccessStatus = (response) => {
    if (setSuccessAuthModal && appProperties?.providerCommonObj?.onAuthorizeOpenSuccessModal) {
      setSuccessAuthModal(true);
    }
    setAuthorizationSuccess(response);
  };

  useEffect(() => {
    if (appProperties?.providerCommonObj) {
      var appLogoName = appProperties?.providerCommonObj?.app + ".png";

      setAppLogo(servicesImages[appLogoName]);
      setRightServiceTitle(appProperties?.providerCommonObj?.title);
      setAuthorizeType(appProperties?.providerCommonObj?.AuthorizationType);
    }
  }, [appProperties?.providerCommonObj]);

  useEffect(() => {
    if (authorizationSuccess && integId) {
      var subscriptionId = "";
      const Body = {
        inboundSMS: "true",
        subscriptionId: subscriptionId,
        isLeft: false,
      };
      appProperties.setLoading(true);
      fetchData(`omessage/completeinstallation?integId=${integId}`, "POST", Body, appProperties)
        .then((response) => {
          let phone;
          let responseDataJson;
          if (response) {
            responseDataJson = JSON.parse(response);
            if (responseDataJson?.data?.phone) {
              phone = responseDataJson?.data?.phone;
            }
          }
          setRightServiceObj((prev) => ({
            ...prev,
            authorized: true,
            completeInstallationDone: Math.random(),
          }));
          setAppProperties((prev) => {
            const installedApps = prev && prev.installedApps ? prev.installedApps : [];
            const rightServiceObjExists = rightServiceObj !== undefined && rightServiceObj !== null;
            const existingIndex = rightServiceObjExists
              ? installedApps?.findIndex((app) => app.integProps?.integId === rightServiceObj.integId)
              : -1;
            if (existingIndex !== -1) {
              const updatedApps = [...installedApps];
              updatedApps[existingIndex] = {
                ...updatedApps[existingIndex],
                right: {
                  ...(updatedApps[existingIndex]?.right || {}),
                  auth: { authorized: true, url: true },
                  service_id: rightServiceObj?.serviceId,
                  service_name: rightServiceObj?.rightServiceName,
                  service_display_name: rightServiceObj?.service_display_name,
                },
              };
              return {
                ...prev,
                authorizeObj: null,
                authObj: null,
                serviceInstalled: true,
                installedApps: updatedApps,
                licenseObj: {
                  ...(prev?.licenseObj || {}),
                  licenseDetails: { ...(prev?.licenseObj?.licenseDetails || {}), ...(responseDataJson?.data?.omniLicense || {}) },
                },
                randomIntegId: prev?.randomIntegId ? prev?.randomIntegId : rightServiceObj?.integId,
                savedNumbers: phone
                  ? [...(prev?.savedNumbers?.filter((obj) => obj?.phoneNumber !== phone?.phoneNumber) || []), phone]
                  : [...(prev?.savedNumbers || [])],
                allNumbers: phone
                  ? [...(prev?.allNumbers?.filter((obj) => obj?.phoneNumber !== phone?.phoneNumber) || []), phone]
                  : [...(prev?.allNumbers || [])],
              };
            } else {
              return {
                ...prev,
                authorizeObj: null,
                serviceInstalled: true,
                authObj: null,
                randomIntegId: prev?.randomIntegId ? prev?.randomIntegId : rightServiceObj?.integId,
                licenseObj: {
                  ...(prev?.licenseObj || {}),
                  licenseDetails: { ...(prev?.licenseObj?.licenseDetails || {}), ...(responseDataJson?.data?.omniLicense || {}) },
                },
                savedNumbers: phone
                  ? [...(prev?.savedNumbers?.filter((obj) => obj?.phoneNumber !== phone?.phoneNumber) || []), phone]
                  : [...(prev?.savedNumbers || [])],
                allNumbers: phone
                  ? [...(prev?.allNumbers?.filter((obj) => obj?.phoneNumber !== phone?.phoneNumber) || []), phone]
                  : [...(prev?.allNumbers || [])],
                installedApps: [
                  ...installedApps,
                  {
                    integProps: rightServiceObj,
                    left: {},
                    right: {
                      auth: { authorized: true, url: true },
                      serviceType: rightServiceObj?.serviceType || "SMS",
                      service_id: rightServiceObj?.serviceId,
                      service_name: rightServiceObj?.rightServiceName,
                      service_display_name: rightServiceObj?.service_display_name,
                    },
                  },
                ],
              };
            }
          });
          onAuthorizationSuccess();
          const responseData = JSON.parse(response);
          const subscriptionIdResponse = JSON.parse(responseData.data.data);
          var subscriptionId = "";
          if (subscriptionIdResponse?.SMSProvider?.subscriptionId) {
            subscriptionId = subscriptionIdResponse.SMSProvider.subscriptionId;
          }
        })
        .catch((err) => {})
        .finally(() => appProperties.setLoading(false));
    }
  }, [authorizationSuccess, onAuthorizationSuccess]);

  function Note() {
    return <div className="mb-4">{appProperties.providerCommonObj?.note}</div>;
  }

  return (
    <div className="authStyle bg-white hs-border-grey hs-lg-h-700-px hs-border-6" style={{ paddingTop: 24, paddingBottom: 40 }} data-cy="channel-authorize-panel">
      <Col offset={1} className="px-lg-2">
        <Logo appLogo={appLogo} />
        <Title rightServiceTitle={rightServiceTitle} />
        {appProperties.providerCommonObj?.description && (
          <Description
            description={appProperties.providerCommonObj?.description}
            descriptionTitle={appProperties.providerCommonObj?.descriptionTitle}
          />
        )}
        <Note />
        <Authorize
          authorizeButtonName={authorizeButtonName}
          setRightServiceObj={setRightServiceObj}
          rightServiceObj={rightServiceObj}
          authorizeType={authorizeType}
          propsData={propsData}
          authorizationSuccess={authorizationSuccessStatus}
          appProperties={appProperties}
          setAppProperties={setAppProperties}
        />
        {rightServiceObj?.isTrialAccount === "true" && (
          <div className="p-3 trialAccount">
            <div className="d-flex align-items-center flex-row gap-2">
              <ExclamationCircleOutlined style={{ fontSize: 25, color: "#FF9800" }} />
              <h6 style={{ color: "#FF9800", fontWeight: "bolder" }} className="mt-2">
                You're on a Twilio trial.
              </h6>
            </div>

            {rightServiceObj?.rightServiceName === "twilio_voice" ? (
              <>
                <div style={{ fontWeight: "bolder" }}>Why Inbound Calls Don’t Work on Twilio Trial Accounts</div>
                <div>
                  Inbound calls to Twilio phone numbers in trial accounts are restricted due to security measures. Specifically, inbound calls
                  will only work if the caller’s phone number has been verified in your Twilio trial account. If someone tries to call your
                  Twilio number from a phone number that is not verified, the call will not connect.
                </div>
                <div style={{ fontWeight: "bolder" }} className="mt-2">
                  To receive inbound calls and make outbound calls during Twilio trial, always verify the caller’s phone number in your Twilio
                  Console first.
                </div>
              </>
            ) : (
              <div className="mt-3">
                When using a Twilio trial account, SMS messages are limited to verified numbers only. To access the full range of HelloSend's SMS
                messaging services, you have two options: upgrade your Twilio account or purchase a number from us using the 'Buy Number' option.
              </div>
            )}
          </div>
        )}
      </Col>
    </div>
  );
}

const Title = React.memo((props) => {
  const { rightServiceTitle } = props;

  return (
    <>
      <div id="appTitle" style={{ display: "flex", alignItems: "center" }}>
        {rightServiceTitle}
      </div>
    </>
  );
});

const Description = React.memo((props) => {
  const { description, descriptionTitle } = props;
  return (
    <>
      <div className="hs-fw-500">{descriptionTitle}</div>
      <div id="description" className="hs-color-dark-grey" style={{ whiteSpace: "pre-line" }}>
        {description}
      </div>
    </>
  );
});
const Authorize = React.memo((props) => {
  const { authorizeType, authorizeButtonName, rightServiceObj, setRightServiceObj, authorizationSuccess, appProperties, propsData } = props;
  const [openModal, setOpenModal] = useState(false);
  const { fetchData } = useHttp();
  let urlParams = new URLSearchParams(window.location.search);
  let userIds = urlParams.get("userId");
  const userId = appProperties.userId || userIds;
  const [isLoadingAuthorizeBtn, setIsLoadingAuthorizeBtn] = useState(false);

  const openAuthorizationPopup = async ({ url, onMessage, width = 700, height = 700, left = 450, top = 100 }) => {
    return new Promise((resolve, reject) => {
      const authWindow = window.open(url, "", `width=${width},height=${height},left=${left},top=${top}`);

      const receiveMessage = (event) => {
        try {
          if (event?.data) {
            let messageData = event.data;
            if (typeof messageData === "string") {
              messageData = JSON.parse(messageData);
            }
            onMessage(messageData);
            resolve(messageData);
          }
        } catch (err) {
          console.error("Error processing message from popup:", err);
          reject(err);
        }
      };

      window.addEventListener("message", receiveMessage);

      const cleanup = () => {
        authWindow?.close();
        window?.removeEventListener?.("message", receiveMessage);
      };

      authWindow.onbeforeunload = cleanup;

      return () => cleanup();
    });
  };

  const doAuthorization = () => {
    return new Promise(async (resolve) => {
      let integIdNew = "";
      let redirectUrl = null;
      let serviceType = null;
      setIsLoadingAuthorizeBtn(true);
      try {
        if (!propsData.integId && propsData.serviceId && userId) {
          const integrationResp = await fetchData(
            `integration/new?userId=${userId}`,
            "POST",
            {
              left_service_id: appProperties.leftServiceId,
              osync_id: appProperties.osyncId,
              right_service_id: propsData.serviceId,
            },
            appProperties
          );
          const parsedIntegrationResp = JSON.parse(integrationResp);
          integIdNew = parsedIntegrationResp.data.integId;
          serviceType = parsedIntegrationResp.data.right.serviceType;
          redirectUrl = parsedIntegrationResp.data.right.auth.url;
        }
        const stateValue = propsData.integId ? propsData.integId : integIdNew;

        if (stateValue && !redirectUrl) {
          fetchData(`authorization/${stateValue}?userId=${userId}`, "GET", null, appProperties).then((responseData) => {
            const data = JSON.parse(responseData);
            serviceType = data?.data?.right?.serviceType;
            if (data?.data?.right?.auth?.url) {
              resolve(data.data.right.auth.url);
            }
          });
        } else if (redirectUrl) {
          resolve(redirectUrl);
        }
      } catch (error) {
        console.log("ERROR", error);
        setIsLoadingAuthorizeBtn(false);
      } finally {
        setRightServiceObj((prev) => ({
          ...prev,
          serviceType: serviceType,
        }));
        setIsLoadingAuthorizeBtn(false);
      }
    });
  };

  const onTokenSave = (integId) => {
    setRightServiceObj((prev) => ({
      ...prev,
      integId: integId,
      serviceType: "WHATSAPP",
    }));
    authorizationSuccess(getRandomNumber(3));
  };
  return (
    <>
      {(props.propsData?.authorized !== true || authorizeType === "no_auth") && props.propsData?.serviceId ? (
        authorizeType === "auth" ? (
          <AuthTypeAuthorize props={props} rightServiceObj={rightServiceObj} setRightServiceObj={setRightServiceObj} />
        ) : authorizeType === "oauth" ? (
          <OauthTypeAuthorize
            openAuthorizationPopup={openAuthorizationPopup}
            doAuthorization={doAuthorization}
            authorizeButtonName={authorizeButtonName}
            props={props}
            rightServiceObj={rightServiceObj}
            setRightServiceObj={setRightServiceObj}
          />
        ) : authorizeType === "oauth_sdk" ? (
          <OauthSdkTypeAuthorize
            onTokenSave={onTokenSave}
            doAuthorization={doAuthorization}
            authorizeButtonName={authorizeButtonName}
            isLoadingAuthorizeBtn={isLoadingAuthorizeBtn}
            setIsLoadingAuthorizeBtn={setIsLoadingAuthorizeBtn}
            props={props}
            rightServiceObj={rightServiceObj}
            setRightServiceObj={setRightServiceObj}
            authorizationSuccess={authorizationSuccess}
          />
        ) : authorizeType === "unipile_auth" ? (
          <UnipileAuthTypeAuthorize
            doAuthorization={doAuthorization}
            authorizeButtonName={authorizeButtonName}
            isLoadingAuthorizeBtn={isLoadingAuthorizeBtn}
            setIsLoadingAuthorizeBtn={setIsLoadingAuthorizeBtn}
            props={props}
            rightServiceObj={rightServiceObj}
            setRightServiceObj={setRightServiceObj}
            authorizationSuccess={authorizationSuccess}
          />
        ) : (
          <NoAuthCustomFlow
            openAuthorizationPopup={openAuthorizationPopup}
            props={props}
            rightServiceObj={rightServiceObj}
            setRightServiceObj={setRightServiceObj}
          />
        )
      ) : (
        <AuthorizationStatus
          authorized={props.propsData?.authorized === true}
          setRightServiceObj={setRightServiceObj}
          appProperties={appProperties}
          setAppProperties={props?.setAppProperties}
          propsData={props.propsData}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      )}
    </>
  );
});

const NoAuthCustomFlow = (props) => {
  const { propsData } = props.props;
  const { rightServiceObj, setRightServiceObj, openAuthorizationPopup } = props;
  const { appProperties } = props.props;
  const { setAppProperties } = props.props;
  const navigate = useNavigate();
  const { fetchData } = useHttp();
  const [isLoadingAuthorizeBtn, setIsLoadingAuthorizeBtn] = useState(false);

  const DoAuthorization = async () => {
    setIsLoadingAuthorizeBtn(true);
    try {
      const redirectUrl = await appProperties?.controller.getCustomAuthUrl(appProperties);

      await openAuthorizationPopup({
        url: redirectUrl,
        onMessage: (status) => {
          if (status?.data?.osyncId) {
            setRightServiceObj((prev) => ({
              ...prev,
              callPhoneNumbersFromService: true,
            }));
            successNotification("Service connected successfully! Proceed to add a phone number.");
          }
        },
      });
    } catch (error) {
      console.error("Authorization failed:", error);
    } finally {
      setIsLoadingAuthorizeBtn(false);
    }
  };

  const createSubAccountAndAuthorize = async () => {
    if (!rightServiceObj?.authorized) {
      const responseObj = await handleBuyNumberClick(
        appProperties,
        setAppProperties,
        fetchData,
        setIsLoadingAuthorizeBtn,
        () => {},
        navigate,
        "teams_helloSend"
      );

      if (responseObj.helloSendAccountId) {
        setRightServiceObj((prev) => ({
          ...prev,
          integId: responseObj?.integId,
          authorized: true,
        }));
        setAppProperties((prev) => {
          const installedApps = prev && prev.installedApps ? prev.installedApps : [];
          const rightServiceObjExists = rightServiceObj !== undefined && rightServiceObj !== null;
          const existingIndex = rightServiceObjExists
            ? installedApps?.findIndex((app) => app.integProps?.integId === rightServiceObj.integId)
            : -1;
          if (existingIndex !== -1) {
            const updatedApps = [...installedApps];
            updatedApps[existingIndex] = {
              ...updatedApps[existingIndex],
              right: {
                auth: { authorized: true, url: true },
                serviceType: rightServiceObj?.serviceType || "SMS", //SMS3
                service_id: rightServiceObj?.serviceId,
                service_name: rightServiceObj?.rightServiceName,
                service_display_name: rightServiceObj?.service_display_name,
              },
            };
            return {
              ...prev,
              authObj: null,
              serviceInstalled: true,
              installedApps: updatedApps,
              randomIntegId: prev?.randomIntegId ? prev?.randomIntegId : rightServiceObj?.integId,
            };
          } else {
            rightServiceObj.integId = responseObj?.integId;
            rightServiceObj.authorized = true;
            return {
              ...prev,
              authObj: null,
              serviceInstalled: true,
              randomIntegId: prev?.randomIntegId ? prev?.randomIntegId : responseObj?.integId,
              installedApps: [
                ...installedApps,
                {
                  integProps: rightServiceObj,
                  left: {},
                  right: {
                    auth: { authorized: true, url: true },
                    serviceType: rightServiceObj?.serviceType || "SMS", //SMS4
                    service_id: rightServiceObj?.serviceId,
                    service_name: rightServiceObj?.rightServiceName,
                    service_display_name: rightServiceObj?.service_display_name,
                  },
                },
              ],
            };
          }
        });
        DoAuthorization();
      } else {
        HNotification.notify({type: "error", message: "Error", description: "Authorization failed"});
      }
    } else if (!rightServiceObj?.customAuth) {
      DoAuthorization();
    }
  };

  return (
    <div className="d-flex align-items-center">
      {propsData?.authorized && rightServiceObj?.customAuth ? (
        <>
          <div
            className="auth-btn d-flex align-items-center"
            style={{ color: "#43BE6F", textDecoration: "none", fontSize: "14px", width: "7rem", cursor: "default" }}
          >
            <div className="actionIconsSprite addAuthorizedIcon"></div>
            <span style={{ marginLeft: "0.25rem" }}>Authorized</span>
          </div>
        </>
      ) : (
        <HButton buttonClassName="hs-fs-16 px-3 mt-2" onClick={createSubAccountAndAuthorize} loading={isLoadingAuthorizeBtn} size="l">
          Authorize
        </HButton>
      )}
    </div>
  );
};
const OauthTypeAuthorize = React.memo((props) => {
  const { authorizeButtonName, authorizationSuccess } = props.props;
  const { propsData } = props.props;
  const { setRightServiceObj, doAuthorization, openAuthorizationPopup } = props;
  const { appProperties } = props.props;
  const { setAppProperties } = props.props;

  const [isLoadingAuthorizeBtn, setIsLoadingAuthorizeBtn] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  async function DoAuthorization() {
    doAuthorization().then(async (redirectUrl) => {
      console.log("CTC redirectUrl", redirectUrl);
      if (redirectUrl) {
        try {
          await openAuthorizationPopup({
            url: redirectUrl,
            onMessage: (statusOfRingcentralAuth) => {
              if (statusOfRingcentralAuth?.data?.integId) {
                setRightServiceObj((prev) => ({
                  ...prev,
                  integId: statusOfRingcentralAuth.data.integId,
                }));
                authorizationSuccess(statusOfRingcentralAuth.status);
              }
            },
          });
        } catch (error) {
          console.error("Authorization failed:", error);
        } finally {
          setIsLoadingAuthorizeBtn(false);
        }
      }
    });
  }

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        {propsData?.authorized !== true && propsData?.serviceId ? (
          <HButton type="primary" onClick={DoAuthorization} buttonClassName="w-50" loading={isLoadingAuthorizeBtn}>
            {propsData?.authorized === true ? "Authorized" : authorizeButtonName ?? "Authorize"}
          </HButton>
        ) : null}
        <AuthorizationStatus
          authorized={propsData?.authorized === true}
          setOpenModal={setOpenModal}
          setRightServiceObj={setRightServiceObj}
          appProperties={appProperties}
          setAppProperties={setAppProperties}
          openModal={openModal}
          propsData={propsData}
        />
      </div>
    </div>
  );
});

const AuthTypeAuthorize = React.memo((props) => {
  const { propsData } = props.props;
  const { appProperties } = props.props;
  const { setAppProperties } = props.props;
  const { setRightServiceObj } = props;
  const { rightServiceObj } = props;
  const [isLoadingAuthorizeBtn, setIsLoadingAuthorizeBtn] = useState(false);
  const [emptySid, setEmptySid] = useState(false);
  const [emptyToken, setEmptyToken] = useState(false);
  const [mismatchCreds, setMismatchCreds] = useState(false);
  const [sid, setSid] = useState("");
  const [token, setToken] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const osyncId = propsData.osyncId;
  const serviceId = propsData.serviceId;
  const { fetchData } = useHttp();
  const path = window.location.pathname;

  const doAuthorization = async () => {
    if (propsData?.authorized !== true) {
      if (sid === "") {
        setEmptySid(true);
        setIsLoadingAuthorizeBtn(false);
      } else if (token === "") {
        setEmptyToken(true);
      } else if ((sid !== "") & (token !== "")) {
        setIsLoadingAuthorizeBtn(true);
        setMismatchCreds(false);
        let integIdNew = "";
        try {
          if (!propsData.integId && serviceId && appProperties?.userId) {
            const integrationResp = await fetchData(
              `integration/new?userId=${appProperties?.userId}`,
              "POST",
              {
                left_service_id: appProperties.leftServiceId,
                osync_id: osyncId,
                right_service_id: serviceId,
              },
              appProperties
            );
            var parsedIntegrationResp;
            if (integrationResp) {
              parsedIntegrationResp = JSON.parse(integrationResp);
            }
            integIdNew = parsedIntegrationResp.data.integId;
          }
          const stateValue = propsData.integId ? propsData.integId : integIdNew;
          if (stateValue && appProperties.leftServiceId) {
            const apiData = {
              access_token: token,
              state: osyncId + "::" + serviceId + "::" + stateValue + "::false",
              refresh_token: "",
              api_domain: sid,
              twilio_account_sid: sid,
            };
            const saveApiKeyResp = await fetchData("saveApiKey", "POST", apiData, appProperties);
            const data = JSON.parse(saveApiKeyResp);
            if (data?.data?.data?.isValidApiKeys) {
              successNotification("Service connected successfully! Proceed to add a phone number.");
              setRightServiceObj((prev) => ({
                ...prev,
                integId: data?.data?.data?.integId,
                serviceType: data?.data?.data?.serviceType,
                authorized: true,
                isTrialAccount: data?.data?.data?.isTrialAccount,
              }));
              setAppProperties((prev) => {
                const installedApps = prev && prev.installedApps ? prev.installedApps : [];
                const rightServiceObjExists = rightServiceObj !== undefined && rightServiceObj !== null;
                const existingIndex = rightServiceObjExists
                  ? installedApps?.findIndex((app) => app.integProps?.integId === rightServiceObj.integId)
                  : -1;
                rightServiceObj.serviceType = data?.data?.data?.serviceType;

                if (existingIndex !== -1) {
                  const updatedApps = [...installedApps];
                  updatedApps[existingIndex] = {
                    ...updatedApps[existingIndex],
                    right: {
                      auth: { authorized: true, url: true },
                      serviceType: rightServiceObj?.serviceType,
                      service_id: rightServiceObj?.serviceId,
                      service_name: rightServiceObj?.rightServiceName,
                      service_display_name: rightServiceObj?.service_display_name,
                      isTrialAccount: data?.data?.data?.isTrialAccount,
                    },
                  };
                  return {
                    ...prev,
                    authorizeObj: null,
                    authObj: null,
                    serviceInstalled: true,
                    installedApps: updatedApps,
                    randomIntegId: prev?.randomIntegId ? prev?.randomIntegId : rightServiceObj?.integId,
                  };
                } else {
                  rightServiceObj.integId = data?.data?.data?.integId;
                  rightServiceObj.authorized = true;
                  rightServiceObj.isTrialAccount = data?.data?.data?.isTrialAccount;

                  return {
                    ...prev,
                    authObj: null,
                    authorizeObj: null,
                    serviceInstalled: true,
                    randomIntegId: prev?.randomIntegId ? prev?.randomIntegId : data?.data?.data?.integId,
                    installedApps: [
                      ...installedApps,
                      {
                        integProps: rightServiceObj,
                        left: {},
                        right: {
                          auth: { authorized: true, url: true },
                          serviceType: rightServiceObj?.serviceType,
                          service_id: rightServiceObj?.serviceId,
                          service_name: rightServiceObj?.rightServiceName,
                          service_display_name: rightServiceObj?.service_display_name,
                          isTrialAccount: data?.data?.data?.isTrialAccount,
                        },
                      },
                    ],
                  };
                }
              });
            } else if (data?.data?.data?.isValidApiKeys === false) {
              setMismatchCreds(true);
            }
          }
        } catch (error) {
          console.log("ERROR", error);
        } finally {
          setIsLoadingAuthorizeBtn(false);
        }
      }
    }
  };
  useEffect(() => {
    if (propsData?.authorized) {
      setToken("*******************");
      setSid("*******************");
    } else {
      setSid("");
      setToken("");
    }
  }, [propsData]);

  return (
    <>
      <div id="auth" className="fontStyle pe-4">
        <p id="emptySid" className="invalid" style={{ visibility: emptySid ? "inherit" : "hidden" }}>
          {labelVariables[propsData.rightServiceName]?.username} is required.
        </p>
        <Input
          formItemLabel={labelVariables[propsData.rightServiceName]?.username}
          tabIndex={"auth1"}
          disabled={propsData?.authorized}
          value={sid}
          data-cy={`messaging_channel_${propsData.rightServiceName}_${labelVariables[propsData.rightServiceName]?.username
            .toLowerCase()
            .replace(/\s+/g, "_")}`}
          onFocus={() => {
            setEmptySid(false);
          }}
          onChange={(value) => {
            console.log("value value.target.value", value.target.value);
            setSid(value.target.value);
          }}
          id="sidInput"
          type="text"
          placeholder={`Enter your ${labelVariables[propsData.rightServiceName]?.username}`}
          required
          variant="underlined"
        ></Input>
        <br />

        <p id="emptyToken" className="invalid" style={{ visibility: emptyToken ? "inherit" : "hidden" }}>
          {labelVariables[propsData.rightServiceName]?.password} is required.
        </p>
        <Input
          formItemLabel={labelVariables[propsData.rightServiceName]?.password}
          tabIndex={"auth2"}
          value={token}
          data-cy={`messaging_channel_${propsData.rightServiceName}_${labelVariables[propsData.rightServiceName]?.password
            .toLowerCase()
            .replace(/\s+/g, "_")}`}
          onFocus={() => {
            setEmptyToken(false);
          }}
          disabled={propsData?.authorized}
          onChange={(value) => {
            setToken(value.target.value);
          }}
          id="tokenInput"
          type="password"
          placeholder={`Enter your ${labelVariables[propsData.rightServiceName]?.password}`}
          required
          variant="underlined"
        ></Input>
        <br />
        <div className="w-100">
          {propsData?.authorized !== true && propsData?.serviceId ? (
            <HButton
              buttonClassName="w-50 mt-lg-2"
              type="primary"
              onClick={doAuthorization}
              data-cy="messaging-channel-authorize-button"
              loading={isLoadingAuthorizeBtn}
              size="xl"
            >
              {propsData?.authorized === true ? "Authorized" : "Authorize"}
            </HButton>
          ) : null}
          <AuthorizationStatus
            authorized={propsData?.authorized === true}
            setOpenModal={setOpenModal}
            setRightServiceObj={setRightServiceObj}
            appProperties={appProperties}
            setAppProperties={setAppProperties}
            openModal={openModal}
            propsData={propsData}
          />
        </div>
        <p id="mismatch" style={{ visibility: mismatchCreds ? "inherit" : "hidden" }}>
          <ExclamationCircleOutlined className="material-icons" />
          <span> </span>
          uh Oh!!...Credentials mismatch
        </p>
      </div>
    </>
  );
});

export default AuthorizePage;

const DisconnectApplication = React.memo((propsData) => {
  const { fetchData } = useHttp();
  const data = propsData.propsData;
  const appProperties = propsData.appProperties;
  const integId = data.integId;
  const setRightServiceObj = propsData.setRightServiceObj;
  const setAppProperties = propsData.setAppProperties;
  const serviceId = data.serviceId;
  const disconnectServiceConfirmationMessage = appProperties?.providerCommonObj?.disconnectServiceConfirmationMessage;
  const [disconnectLoading, setDisconnectLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDisconnectApplication = () => {
    let apiData = "?left_service=" + false + "&integ_id=" + integId + "&service_id=" + serviceId;
    if (integId && serviceId) {
      setDisconnectLoading(true);
      fetchData("revoke" + apiData, "DELETE", null, appProperties)
        .then(function (resp) {
          console.log(resp);
          propsData.setOpenModal(false);
          setAppProperties((prev) => ({
            ...prev,
            installedApps: prev?.installedApps?.map((obj) => ({
              ...obj,
              right: {
                ...obj?.right,
                auth: {
                  ...obj.right.auth,
                  authorized: obj.integProps.integId === integId ? false : obj.right.auth.authorized,
                },
              },
            })),
          }));
          setRightServiceObj((prev) => ({
            ...prev,
            authorized: false,
            isTrialAccount: false,
          }));
          setDisconnectLoading(false);
        })
        .catch((err) => {
          console.log("error", err);
          setDisconnectLoading(false);
        });
    }
  };

  return (
    <>
      <Modal
        open={propsData.openModal}
        className="disconnectModal"
        onCancel={() => {
          propsData.setOpenModal(false);
        }}
        footer={
          <div className="d-flex flex-row align-items-center justify-content-between mt-2 w-100 gap-2">
            <div className="d-flex flex-row align-items-center justify-content-between mt-2 w-50">
              <HButton
                variant="cancel"
                buttonClassName={`d-flex flex-row w-100 h-45 hs-fs-16`}
                onClick={() => {
                  propsData.setOpenModal(false);
                }}
              >
                Cancel
              </HButton>
            </div>
            <div className="d-flex flex-row align-items-center justify-content-end mt-2 w-50">
              <HButton
                type="danger"
                buttonClassName={`d-flex flex-row w-100 h-45 hs-fs-16`}
                data-cy="disconnect-btn"
                onClick={handleDisconnectApplication}
              >
                Disconnect
              </HButton>
            </div>

            {loading && <CommonLoadingV2 />}
          </div>
        }
      >
        <Row>
          <Col span={22}>
            <div className="d-flex align-items-center mb-3">
              <div className="actionIconsSprite disConnectIcon me-4"></div>
            </div>
          </Col>
          <Col
            span={2}
            onClick={() => {
              propsData.setOpenModal(false);
            }}
          >
            <div className="m-2 p-1 pt-2 pe-2">
              <div className="actionIconsSprite closeIconBig me-4"></div>
            </div>
          </Col>
        </Row>
        <div className="hs-fw-600 hs-fs-16 hs-color-blackRussian mb-1">Are you sure you want to disconnect?</div>
        <div className="pb-3 hs-fs-14">
          {disconnectServiceConfirmationMessage}
        </div>
      </Modal>
    </>
  );
});

const OauthSdkTypeAuthorize = React.memo((props) => {
  const { authorizeButtonName } = props.props;
  const { propsData } = props.props;
  const { setRightServiceObj, isLoadingAuthorizeBtn, doAuthorization, onTokenSave, setIsLoadingAuthorizeBtn } = props;
  const { appProperties } = props.props;
  const { setAppProperties } = props.props;

  const [openModal, setOpenModal] = useState(false);

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        {propsData?.authorized !== true && propsData?.serviceId ? (
          <AuthorizeButtonForSdkType
            onTokenSave={onTokenSave}
            buttonName={authorizeButtonName || "Authorize"}
            loading={isLoadingAuthorizeBtn}
            setIsLoadingAuthorizeBtn={setIsLoadingAuthorizeBtn}
            appProperties={appProperties}
            doAuthorization={doAuthorization}
          />
        ) : null}
        <AuthorizationStatus
          authorized={propsData?.authorized === true}
          setOpenModal={setOpenModal}
          setRightServiceObj={setRightServiceObj}
          appProperties={appProperties}
          setAppProperties={setAppProperties}
          openModal={openModal}
          propsData={propsData}
        />
      </div>
    </div>
  );
});

const AuthorizationStatus = ({ authorized, setOpenModal, setRightServiceObj, appProperties, setAppProperties, openModal, propsData }) => {
  if (!authorized) return null;
  const showDailyLimitReachedWarning = appProperties?.savedNumbers?.some(
    (number) => number?.integId === propsData?.integId && number?.showDailyLimitReachedWarning
  );

  return (
    <>
      {showDailyLimitReachedWarning && propsData?.serviceId && (
        <div className="hs-w-90">
          <MessageAreaInfo
            message={getHighUsageAlertMessage(findServiceInfoByServiceId(appProperties, propsData?.serviceId)?.displayName)}
            type="warning"
            key="daily-limit-reached-warning"
          />
        </div>
      )}
      <Row justify="center" style={{ border: "2px solid #4CAF50", borderRadius: 12 }} className="p-2 mb-3 me-5">
        <Col span={3} xl={3} md={3} className="w-100">
          <div className="d-flex justify-content-center">
            <div className="actionIconsSprite addAuthorizedIcon" style={{ cursor: "default" }}></div>
          </div>
        </Col>
        <Col span={21} xl={19} md={16} className="my-auto ms-2">
          <span style={{ fontWeight: 600 }}>Authorization completed!</span>
          <div style={{ fontSize: 12, color: "#374151" }} className="mt-1">
            Your service has been successfully authorized, and all necessary consents have been obtained.
          </div>
        </Col>
      </Row>
      <div className="auth-btn d-flex align-items-center">
        <div
          data-cy="revoke-auth-btn"
          style={{
            height: 24,
            width: "auto",
            borderRadius: 12,
            textDecoration: "none",
            color: "#E71D36",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => {
            setOpenModal(true);
          }}
        >
          <div className="actionIconsSprite revokeIcon"></div>
          <span style={{ marginLeft: "0.25rem", fontSize: 14 }}>Revoke</span>
        </div>
      </div>
      <DisconnectApplication
        setRightServiceObj={setRightServiceObj}
        appProperties={appProperties}
        setAppProperties={setAppProperties}
        propsData={propsData}
        openModal={openModal}
        setOpenModal={setOpenModal}
        integId={propsData?.integId}
      />
    </>
  );
};

function UnipileAuthTypeAuthorize(props) {
  const { propsData } = props.props;
  const { setRightServiceObj } = props;
  const { appProperties } = props.props;
  const { setAppProperties } = props.props;
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      {propsData?.authorized !== true && propsData?.serviceId ? (
        <AuthorizeButtonForUnipileAuth {...props} authorizeButtonName={props?.authorizeButtonName} />
      ) : null}

      <AuthorizationStatus
        authorized={propsData?.authorized === true}
        setOpenModal={setOpenModal}
        setRightServiceObj={setRightServiceObj}
        appProperties={appProperties}
        setAppProperties={setAppProperties}
        openModal={openModal}
        propsData={propsData}
      />
    </>
  );
}
